import DSponsorPage from './DSponsorPage'

export default DSponsorPage
